// Pages/Education/AddEducation.jsx

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateEducationMutation } from "../../redux/services/educationService/education.Services";

function AddEducation() {
    const navigate = useNavigate();
    // ✅ CORRECTED: Using useCreateEducationMutation
    const [createEducation, { isLoading }] = useCreateEducationMutation();
    const [formData, setFormData] = useState({
        education_name: "", // ✅ CORRECTED: education_name instead of name
        status: "active",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.education_name.trim()) {
            errorToast("Education name is required");
            return;
        }

        try {
            const response = await createEducation(formData).unwrap();
            console.log(response);
            successToast(response?.message || "Education Created Successfully");
            navigate("/education"); // ✅ Navigate to education list
        } catch (error) {
            console.log(error);
            errorToast(error?.data?.message || "Failed To Create Education");
        }
    };

    return (
        <div>
            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            Add Education
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                Add Education
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate("/education")}
                    >
                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>
                        Education List
                    </button>
                </div>
            </div>

            {/* FORM */}
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="container">
                            <div className="row align-items-end">
                                {/* INPUT */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>
                                            Enter Education <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className='form-control custumform'
                                            placeholder='Enter Education Name'
                                            name="education_name"
                                            value={formData.education_name}
                                            onChange={handleChange}
                                            required
                                            autoFocus
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <label>Status</label>
                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>

                                {/* BUTTON */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <div className="button_submit">
                                            <button
                                                type="submit"
                                                className='btn btn-primary'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Creating...
                                                    </>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddEducation;